import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQuery } from "@/shared/utils/baseQuery";

export const equipmentsApi = createApi({
  reducerPath: "equipmentsApi",
  baseQuery: createBaseQuery("https://api.fitkeep.ru/"),
  endpoints: (builder) => ({
    getEquipments: builder.query({
      query: () => "/equipments",
    }),
    updateEquipments: builder.mutation({
      query: (updateData) => ({
        url: "/equipments/update",
        method: "POST",
        body: updateData,
      }),
    }),
    getUpdatedEquipments: builder.mutation<any, any>({
      query: (choicesData = {}) => ({
        url: "/equipments/fromuser",
        method: "POST",
        body: choicesData,
      }),
    }),
    getUserProgress: builder.mutation<any, void>({
      query: () => ({
        url: "/user/progres",
        method: "POST",
        body: {},
      }),
    }),
  }),
});
export const {
  useGetEquipmentsQuery,
  useUpdateEquipmentsMutation,
  useGetUpdatedEquipmentsMutation,
  useGetUserProgressMutation,
} = equipmentsApi;
